import { db } from '@/data/firebase/config';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { Newsletter } from '@/domain/types/collections';
import { useAdminLogger } from '@/domain/use-cases/admin-logger';
import FormAddDocument from '@/presentation/components/form-add-document';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const NewsletterAddPage = () => {
  const navigate = useNavigate();
  const { logCreate } = useAdminLogger();

  const handleSave = async (data: Newsletter) => {
    try {
      const docRef = await addDoc(collection(db, DOCUMENTS_DB.NEWSLETTERS), {
        ...data,
        createdAt: serverTimestamp(),
      });

      // Log the action
      await logCreate(DOCUMENTS_DB.NEWSLETTERS, docRef.id, data.title, data);

      toast.success('Documento guardado correctamente', {
        theme: 'colored',
      });
      navigate('/dashboard/newsletters');
    } catch (error) {
      toast.error('Error al guardar el documento', {
        theme: 'colored',
      });
      // Re-thrown so FormAddDocument knows the save failed and keeps the
      // autosaved draft instead of deleting the user's only remaining copy.
      throw error;
    }
  };

  return (
    <div className="p-4 flex flex-col gap-4 ">
      <h1 className="text-3xl font-bold">Agregar Publicación</h1>
      <FormAddDocument onSave={handleSave as any} contentType="newsletter" />
    </div>
  );
};

export default NewsletterAddPage;
